import React, { useRef, useState } from 'react'
import Popover from '../Popover'
import ButtonBase from '../ButtonBase'
import CircleMenuIcon from '../../assets/svgs/menu-circle.svg'
import OvalMenuIcon from '../../assets/svgs/menu-oval.svg'
import './MenuPopover.scss'
import PropTypes from 'prop-types'

/** context menu  */
const MenuPopover = ({ triggerVariant, menuItems, className, popoverClass, ...rest }) => {
  const [isOpen, setIsOpen] = useState(false)
  const close = () => setIsOpen(false)

  return (
    <Popover
      trigger={'click'}
      popoverClass={`Suc-menu-popover ${popoverClass}`}
      containerClass={`Suc-menu-trigger ${isOpen ? 'Suc-active' : ''} ${className}`}
      visible={isOpen}
      onVisibleChange={setIsOpen}
      closeOnTriggerHidden={true}
      container={<ButtonBase>
          {triggerVariant === 'table' && <TableTrigger isActive={isOpen}/>}
          {triggerVariant === 'card' && <CardTrigger isActive={isOpen}/>}
        </ButtonBase>}
      {...rest}
    >
      <ul className="Suc-menu-no-bullet" >
        {menuItems.map((menuItem, index) => (
          <li key={`Suc-menu-item-${index}`} onClick={close}>
            {menuItem}
          </li>)
        )}
      </ul>
    </Popover>
  )
}
MenuPopover.propTypes = {
  /** variant of trigger */
  triggerVariant: PropTypes.oneOf(['card', 'table']),
  /** custom classname */
  className: PropTypes.string,
  /** popover custom classname */
  popoverClass: PropTypes.string,
  /** menuItems */
  menuItems: PropTypes.arrayOf(PropTypes.node)
}

MenuPopover.defaultProps = {
  variant: 'card',
  className: '',
  popoverClass: ''
}
export default MenuPopover

const CardTrigger = ({ isActive }) => {
  return <CircleMenuIcon className={`Suc-circle-trigger ${isActive ? 'Suc-circle-trigger-active' : ''}`}/>
}

const TableTrigger = ({ isActive }) => {
  return <OvalMenuIcon className={`Suc-oval-trigger ${isActive ? 'Suc-oval-trigger-active' : ''}`}/>
}
